import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";

import { checkSeriesDataXDateGreaterThanMin } from "./utils/checkSeriesDataXDateGreaterThanMin";
import { checkSeriesDataXDateLessThanMax } from "./utils/checkSeriesDataXDateLessThanMax";
import { convertToNumber } from "./utils/convertToNumber";

export function declineRateLocks(states: Partial<EvaChartStates>) {
  const { locks, series } = states;

  let lockedYMin = locks?.yMin?.value ?? 0;
  let lockedYMax = locks?.yMax?.value ?? 80; // no product locks here as chart specific lock always overrides

  let lockedXMinType = undefined;
  let lockedXMaxType = undefined;

  const isUserXMinLock = locks?.xMin?.type !== DataEnum.DefaultDate && locks?.xMin?.value;
  const isUserXMaxLock = locks?.xMax?.type !== DataEnum.DefaultDate && locks?.xMax?.value;

  const lockedXMin =
    locks?.xMin?.type === DataEnum.Reset
      ? undefined
      : isUserXMinLock
      ? locks?.xMin?.value
      : checkSeriesDataXDateGreaterThanMin("2000", series);

  const lockedXMax =
    locks?.xMax?.type === DataEnum.Reset
      ? undefined
      : isUserXMaxLock
      ? locks?.xMax?.value
      : checkSeriesDataXDateLessThanMax("2050", series);

  if (locks?.yMin?.type === DataEnum.Reset) lockedYMin = undefined;
  if (locks?.yMax?.type === DataEnum.Reset) lockedYMax = undefined;

  if ((!locks?.xMin?.value && lockedXMin) || locks?.xMin?.type === DataEnum.DefaultDate) {
    lockedXMinType = DataEnum.DefaultDate;
  }

  if ((!locks?.xMax?.value && lockedXMax) || locks?.xMax?.type === DataEnum.DefaultDate) {
    lockedXMaxType = DataEnum.DefaultDate;
  }
  return {
    lockedXMin: lockedXMin,
    lockedXMax: lockedXMax,
    lockedYMin: convertToNumber(lockedYMin),
    lockedYMax: convertToNumber(lockedYMax),
    lockedXMinType: lockedXMinType,
    lockedXMaxType: lockedXMaxType
  };
}
